import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { routerShape } from 'react-router';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import simpleStore from 'helpers/simpleStore';
import Icon, { iconTypes } from 'components/icon';
import Button, { btnViews } from 'components/button';
import ClipboardCopy from 'components/clipboard-copy';
import { ModalButton, Header, Content } from 'components/modal';

import { fbAsyncInit, fbShare } from './fb-actions';

import translates from './share-i18n.json';

import 'styles/base/components/share/_share.scss';

const bemClassesShare = new Bem('share');

/**
 * Поделиться нативным способом устройства
 * (через что-угодно, что установлено)
 *
 * @param obj - { title, text, url }
 * title - заголовок сообщения
 * text - текст сообщения
 * url - урл страницы, которой делятся.
 *
 * !!!ВАЖНО!!! на странице должны быть метатеги 'open graph'.
 * Без них сообщение отправится только с тайтлом и текстом.
 * Без картинки, тайтла и описания с самой страницы.
 */
const nativeShare = (obj) => {
  navigator.share(obj)
    .then(() => console.log('Successful share!')) // eslint-disable-line
    .catch(error => console.log('Error sharing! ', error)); // eslint-disable-line
};

@I18nHoc(translates)
export default class Share extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
    project: PropTypes.oneOf(['domik', 'bild', 'forum', 'bildcontrol', 'a2']),
    inListDD: PropTypes.bool,
    onClose: PropTypes.func
  };

  static contextTypes = {
    router: routerShape
  };

  static addFBSdk(project) {
    const wasInited = simpleStore.get('fbInited');
    if (!wasInited) {
      fbAsyncInit(project);
      simpleStore.set('fbInited', true);
    }

    return (
      <script>
        {(function(d, s, id) { //eslint-disable-line
          const fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;

          const js = d.createElement(s);
          js.id = id;
          js.src = 'https://connect.facebook.net/ru_RU/sdk.js#xfbml=1&version=v3.1';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'))}
      </script>
    );
  }

  static checkForNative() {
    if (__CLIENT__) return !!navigator && !!navigator.share;
    return false;
  }

  static getCurUrl(url, router) {
    let domain = '';
    let pathname = '';

    if (url) return url;

    if (__CLIENT__) {
      domain = window.location.origin;
      pathname = router.location.pathname;
      return `${domain}${pathname}`;
    }

    return null;
  }

  static renderLinks(item, obj) {
    let moreProps = {};
    if (item.addProps) moreProps = { ...item.addProps };

    if (item.renderer) return item.renderer(obj);

    return (
      <a
        key={item.text}
        {...bemClassesShare('btn', ['iconOnly', item.icon])}
        href={item.link(obj)}
        title={item.title}
        onClick={item.onClick}
        rel="nofollow"
        {...moreProps}
      >
        <span {...bemClassesShare('btnContent')}>
          <Icon {...bemClassesShare('icon')} type={item.icon} />
          {/* <span {...bemClassesShare('text')}>{item.text}</span> */}
        </span>
      </a>
    );
  }

  constructor(props, ctx) {
    super(props, ctx);
    this.router = ctx.router;
    this.url = Share.getCurUrl(props.url, this.router);

    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.toggleContentStatus = this.toggleContentStatus.bind(this);
    this.state = {
      contentLoaded: false
    };
  }

  toggleContentStatus() {
    this.setState(
      prevState => ({ contentLoaded: !prevState.contentLoaded }),
      () => {
        if (!this.state.contentLoaded && this.props.onClose) this.props.onClose();
      }
    );
  }

  copyToClipboard() {
    if (this.clipboardCopy) {
      if (this.url) {
        const closeModal = () => {
          if (this.modal) this.modal.closeModal();
        };
        this.clipboardCopy.copy(this.url, closeModal);
      }
    }
  }

  renderModalContent(nativeObj) {
    const { i18n } = this;
    const linksCfg = [
      {
        renderer: ({ url }) => (
          <Button
            key="facebook"
            {...bemClassesShare('btn', 'iconOnly facebook')}
            title={`${i18n('shareLinkText')} Facebook`}
            // label="Facebook"
            iconType={iconTypes.socialFacebook}
            onClick={() => fbShare(url)}
            iconOnly
          />
        )
      }, {
        text: 'Telegram',
        link: ({ url, text, title }) => `tg://msg_url?url=${url}&text=${text || title}`,
        title: `${i18n('shareLinkText')} Telegram`,
        icon: iconTypes.telegram,
      }, {
        text: 'Email',
        link: ({ url, text, title }) => `mailto:?subject=${title}&body=${text} ${url}`,
        title: `${i18n('shareLinkSendText')} Email`,
        icon: iconTypes.letter,
      }
    ];

    return (
      <div {...bemClassesShare('modalContent')}>
        <div {...bemClassesShare('item', 'socials')}>
          {map(linksCfg, it => Share.renderLinks(it, nativeObj))}
        </div>
        <div {...bemClassesShare('item', 'or')}><span {...bemClassesShare('text')} children={i18n('shareOr')} /></div>
        <div {...bemClassesShare('item', 'btnCopy')}>
          <ClipboardCopy ref={el => this.clipboardCopy = el} />
          <Button
            {...bemClassesShare('btn', 'copy')}
            onClick={this.copyToClipboard}
            title={i18n('shareBtnCopyTitle')}
            label={i18n('shareBtnCopyText')}
            iconType={iconTypes.copyLink}
          />
        </div>
      </div>
    );
  }

  render() {
    const { i18n } = this;
    const { inListDD, title = '', text = '', project } = this.props;
    const nativeObj = { title, text, url: this.url };

    return (
      <>
        {this.state.contentLoaded && Share.addFBSdk(project)}
        <ModalButton
          ref={el => this.modal = el}
          buttonProps={{
            onClick: Share.checkForNative() ? nativeShare(nativeObj) : null,
            title: i18n('shareMainText'),
            label: i18n('shareMainText'),
            iconType: iconTypes.share,
            dataView: !inListDD ? btnViews.share : null,
            contentLeft: true,
            inListDD
          }}
          onOpenCallback={this.toggleContentStatus}
          onCloseCallback={this.toggleContentStatus}
          size="small"
          disableNotification={false}
        >
          <Header closeButton>{i18n('shareMainText')}</Header>
          <Content addPaddingB>
            {this.renderModalContent(nativeObj)}
          </Content>
        </ModalButton>
      </>
    );
  }
}
